import React from 'react';
import './avantaje.css';

const Avantaje = ({ title, text }) => {
    if (!title || !text) return;
    return (
        <div className='iconta__avantaje-container__avantaje'>
            
            <div className='iconta__avantaje-container__avantaje-title'>

            <div />
                <h1>{title}</h1>
            </div>
            
            <div className='iconta__avantaje-container__avantaje-text'>
                
                <p>{text}</p>
            </div>
        </div>
    )
}

export default Avantaje;
